import { AppLayout } from "@bcc/components/app-layout";
import { HomeView } from "@bcc/components/views/home-view";

export function HomePage() {
  return (
    <AppLayout>
      <HomeView />
    </AppLayout>
  );
}
